import {
  extractCheque,
  getExtractaadhaar,
  getExtractDL,
  getExtractPassport,
  getExtractVoterID,
  maskedAadhaar,
} from "../../service/generic/otherApi";
export const getDocumentCategory = (proof: any, documentCategory: any) => {
  if (proof === "Aadhar") {
    documentCategory.name = "Aadhar";
    documentCategory.id = 117;
  } else if (proof === "VotersId") {
    documentCategory.name = "VotersId";
    documentCategory.id = 116;
  } else if (proof === "Passport") {
    documentCategory.name = "Passport";
    documentCategory.id = 114;
  } else if (proof === "DrivingLicense") {
    documentCategory.name = "DrivingLicense";
    documentCategory.id = 118;
  }
  return documentCategory;
};
export const getOCRResp = async (type?: any, requestPayload?: any) => {
  let ocrResp: any;
  if (type) {
    switch (type) {
      case "Aadhar":
        ocrResp = await getExtractaadhaar(requestPayload);
        break;
      case "VotersId":
        ocrResp = await getExtractVoterID(requestPayload);
        break;
      case "Passport":
        ocrResp = await getExtractPassport(requestPayload);
        break;
      case "DrivingLicense":
        ocrResp = await getExtractDL(requestPayload);
        break;
      case "MaskAadhar":
        ocrResp = await maskedAadhaar(requestPayload);
        break;
      default:
        ocrResp = "";
        break;
    }
  }
  return ocrResp;
};
export const getAutoQc = async (requestPayload?: any, qcDetails?: any) => {
  let AutoQc: any = "No";
  let qcResp = await extractCheque(requestPayload);
  if (qcResp.status) {
    if (
      qcResp.data.status === "completed" &&
      qcResp.data.result &&
      qcResp.data.result.extraction_output
    ) {
      let result = qcResp.data.result.extraction_output;

      AutoQc =
        (result.account_no
          ? qcDetails?.accNo?.toString().toLowerCase().trim() ===
            result?.account_no?.toString().toLowerCase().trim()
          : false) &&
        (result.ifsc_code
          ? qcDetails?.ifsc?.toString().toLowerCase().trim() ===
            result?.ifsc_code?.toString().toLowerCase().trim()
          : false) &&
        (result.bank_name
          ? qcDetails?.bankName?.toString().toLowerCase().trim() ===
            result?.bank_name?.toString().toLowerCase().trim()
          : false) &&
        (result.micr_code
          ? qcDetails?.micr?.toString().toLowerCase().trim() ===
            result?.micr_code?.toString().toLowerCase().trim()
          : false)
          ? "Yes"
          : "No";
    }
  }
  return AutoQc;
};
export async function getMaskedAdhar(maskObj: any, isMasked?: boolean, skipMask?: boolean) {
  if(skipMask) {
    return {
      fileName: maskObj.fileName,
      fileData: maskObj.fileData,
    }
  }else {
    let base64Resp: any;
    let documentCategory = { name: "", id: 0 };
    documentCategory = getDocumentCategory(maskObj.proof, documentCategory);
    let requestPayload = {
      applicationid: maskObj.accountCode,
      base64document: maskObj.fileData,
      documentcategory: documentCategory.name,
      documentid: documentCategory.id,
      source: "DIY",
    };
    try {
      let ocrResp: any;
      ocrResp = await getOCRResp("MaskAadhar", requestPayload);
      if (
        ocrResp &&
        ocrResp.data &&
        ocrResp.data.result &&
        ocrResp.data.status === "completed" &&
        ocrResp.data.result.base64_image
      ) {
        if (isMasked) {
          base64Resp = { fileData: "", fileName: "" };
          base64Resp.fileData = ocrResp.data.result.base64_image;
          maskObj.fileName = maskObj.fileName.split(".")[0] + ".jpg";
          base64Resp.fileName = maskObj.fileName;
        } else {
          base64Resp = ocrResp.data.result.base64_image;
        }
      } else {
        if (isMasked) {
          base64Resp = { fileData: "", fileName: "" };
          base64Resp.fileData = maskObj.fileData;
          base64Resp.fileName = maskObj.fileName;
        } else {
          base64Resp = maskObj.fileData;
        }
      }
    } catch (error) {
      if (isMasked) {
        base64Resp = { fileData: "", fileName: "" };
        base64Resp.fileData = maskObj.fileData;
        base64Resp.fileName = maskObj.fileName;
      } else {
        base64Resp = maskObj.fileData;
      }
      console.log(error);
    }
    return base64Resp;
  }

}
export const getQCChecked = async function (checkedObj: any) {
  let qcFlag = false;
  if (checkedObj.addressProof !== "NREGAJobCard" && checkedObj.fileData) {
    let documentCategory = { name: "", id: 0 };
    documentCategory = getDocumentCategory(
      checkedObj.addressProof,
      documentCategory
    );
    let requestPayload = {
      applicationid: checkedObj.accountCode,
      base64document: checkedObj.fileData,
      documentcategory: documentCategory.name,
      documentid: documentCategory.id,
      source: "DIY",
    };
    try {
      let ocrResp: any;
      ocrResp = await getOCRResp(documentCategory.name, requestPayload);
      if (
        ocrResp &&
        ocrResp.data &&
        ocrResp.data.status === "completed" &&
        ocrResp.data.result.extraction_output
      ) {
        let result = ocrResp.data.result.extraction_output;
        if (
          result &&
          result.address &&
          result.name_on_card &&
          result.address.toLowerCase() === checkedObj.address.toLowerCase() &&
          result.name_on_card.toLowerCase() ===
            checkedObj.fullName.toLowerCase()
        ) {
          qcFlag = true;
        } else {
          qcFlag = false;
        }
      } else {
        qcFlag = false;
      }
    } catch (error) {
      qcFlag = false;
    }
  }
  return qcFlag ? qcFlag : false;
};
